import { Factory } from './factory';
import { HomeworkLink } from '../homework-link';
import { Worksheet } from '../worksheet';

export class HomeworkFactory implements Factory<HomeworkLink> {

    buildFromFactory(): HomeworkLink {
        return undefined;
    }

    buildFromObject(jsonObject: any, withWorksheet = false): HomeworkLink {
        const homework = new HomeworkLink();
        homework.id = jsonObject.id;
        homework.title = jsonObject.title;
        homework.link = jsonObject.link;
        homework.domain = jsonObject.domain;
        homework.cooldownPhase = jsonObject.cooldownPhase;
        homework.email = jsonObject.email;
        homework.qrCode = jsonObject.qrCode;
        homework.correctionLink = jsonObject.correctionLink;
        homework.downloadLink = jsonObject.downloadLink;
        homework.exercises = jsonObject.exercises;
        homework.created = +jsonObject.created;
        homework.updated = +jsonObject.updated;
        homework.test = Boolean(jsonObject.test);
        homework.printLink = jsonObject.printLink;
        if (jsonObject.worksheet && withWorksheet) {
            const worksheet = new Worksheet();
            worksheet.name = jsonObject.worksheet.name;
            worksheet.id = jsonObject.worksheet.id;
            homework.worksheet = worksheet;
        }
        if (!jsonObject.title) {
           homework.title = jsonObject.description
        }

        return homework;
    }
}
